import React from "react";
import "../style/sign.scss";
import { currentLocale } from "../locale";
import { replace } from "ramda";
import { converter } from "../lib/converter";

export const Notification = ({ children, title }) => {
  return (
    <div className="modal is-active">
      <div className="modal-background" />
      <div className="modal-card">
        <section className="notification is-warning">{children}</section>
      </div>
    </div>
  );
};
export const AboutSignerNotification = ({ children }) => {
  return (
    <div className="modal-card">
      <section
        className="notification is-warning
          has-text-centered"
      >
        {children}
      </section>
    </div>
  );
};

export const SubmitNotification = ({
  inform,
  failed,
  success,
  open,
  handleClose
}) => {
  let className = "notification";
  if (inform) {
    className += " is-info has-text-centered";
  } else if (failed) {
    className += " is-danger";
  } else if (success) {
    className += " is-success";
  }
  let modalClass = "modal";
  if (open) {
    modalClass += " is-active";
  }
  let message;
  if (inform) {
    message = converter.convert(`${currentLocale.submitting}`);
  } else if (failed) {
    message = `${currentLocale.submitFail}`;
  } else if (success) {
    message = `${currentLocale.submitSucceeded}`;
  }
  let buttonClass;
  if (inform) {
    buttonClass = "is-invisible";
  } else {
    buttonClass = "button";
  }
  return (
    <div className={modalClass} style={{ zIndex: 9999 }}>
      <div className="modal-background" />
      <div className={className}>
        <section>{message}</section>
        <button type="button" onClick={handleClose} className={buttonClass}>
          Close
        </button>
      </div>
    </div>
  );
};

export const AccessDeniedNotification = ({ inform, open, handleClose }) => {
  let modalClass = "modal";
  if (open) {
    modalClass += " is-active";
  }
  const message = replace(
    "{{-Site-}}",
    window.location.origin,
    `${currentLocale.accessDenied}`
  );

  return (
    <div className="modal is-active" style={{ zIndex: 9999 }}>
      <div className="modal-background" />
      <div className="notification is-danger">
        <section>{message}</section>
        {/* <button type="button" onClick={handleClose} className="button">Close</button> */}
      </div>
    </div>
  );
};
export const Progress = ({}) => {
  return (
    <div className="modal is-active" style={{ zIndex: 9999 }}>
      <div className="modal-background" />
    </div>
  );
};
